import { NotificationManager } from 'react-notifications';
import { Actions as COMPANYACTIONS } from "../../../../store/actions/companyActions";
import { constructQueryParams, getCurrency } from '../../../common/validation/Validators';

import apiURL from '../../../../store/actions/apiURL';
import axios from 'axios';

const Types = {
    XERO_SEND_DATA: "XERO_SEND_DATA",
    XERO_UPDATE_CONTACTS: "XERO_UPDATE_CONTACTS",
    XERO_EMPLOYEE_LINKS: "XERO_EMPLOYEE_LINKS",
    XERO_UPDATE_SETTINGS: "XERO_UPDATE_SETTINGS",
    XERO_SAVING_DATA: "XERO_SAVING_DATA",
};

const setSendingData = (periodId, status) => ({
    type: Types.XERO_SEND_DATA,
    periodId,
    status
});
const setSavingData = (status) => ({
    type: Types.XERO_SAVING_DATA,
    status
});

const updateXeroSettings = (payload) => ({
    type: Types.XERO_UPDATE_SETTINGS,
    payload
});

const updateContactOptions = (contacts) => ({
    type: Types.XERO_UPDATE_CONTACTS,
    contacts
})

const isConnectedToXero = () => {
    return async (dispatch, getState) => {
        const state = getState()
        const { jurisdiction } = { ...state.company?.settings }
        await fetch(apiURL + "/xero/is-connected", {
            // fetch('http://localhost:3000/report/templates' , {
            credentials: "include",
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then(async (data) => {
                const { url, ['xero-tenant-id']: tenant, tenants } = { ...data }
                if (!data.connected || data.tenants?.length <= 0) return
                dispatch(getXeroSettings())
                dispatch(updateXeroSettings({
                    connectLink: url,
                    tenant,
                    tenants: tenants?.map((tenant) => {
                        const hasCurrency = tenant.currencies?.find(item => item == (getCurrency(jurisdiction)))
                        return {
                            label: tenant?.tenantName ?? tenant?.organisation?.Name,
                            value: tenant.tenantId,
                            connectionId: tenant.id,
                            hasCurrency
                        }
                    }),
                }))
            })
            .catch((error) => {
                console.error('Error Getting Xero Connections: ', error)
            })
    }
}

const saveXeroSettings = (settings) => {
    return async (dispatch, getState) => {
        dispatch(setSavingData(true))
        await fetch(apiURL + "/xero/settings", {
            // fetch('http://localhost:3000/report/templates' , {
            credentials: "include",
            method: "POST",
            body: JSON.stringify(settings),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                dispatch(getXeroSettings())
                NotificationManager.success('Xero Settings Saved Successfully!', 'Saving Xero Settings')
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error('Error Saving Xero Settings', 'Saving Xero Settings')
            })
        dispatch(setSavingData())
    }
}

const getXeroSettings = () => {
    return async (dispatch, getState) => {
        await fetch(apiURL + "/xero/all-settings", {
            // fetch('http://localhost:3000/report/templates' , {
            credentials: "include",
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                const { settings, accounts, taxNames, taxRates, tracking, trackingCategories, payruns } = { ...data }
                dispatch(updateXeroSettings({
                    accounts: accounts?.filter(account => !!account.Code && account.Status == 'ACTIVE')?.map((account) => ({
                        label: account.Name,
                        value: account.Code,
                        id: account.AccountID,
                    })),
                    taxNames,
                    taxRates,
                    payruns,
                    tracking,
                    trackingCategories: trackingCategories?.map((category) => ({
                        label: category.Name,
                        value: category.TrackingCategoryID,
                    })),
                    settings: {
                        basicPayableTo: {
                            label: "To Each Individual Employee",
                            value: "employee",
                        },
                        ...settings?.settings
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error("Error Getting Xero Settings", "Xero Settings")
            })
    }
}

const disconnectOrganisation = (connectionId) => {
    return async (dispatch, getState) => {
        const state = getState()
        const { tenants } = { ...state.integration?.accounting?.xero }
        fetch(apiURL + `/xero/connection/${connectionId}`, {
            // fetch('http://localhost:3000/report/templates' , {
            credentials: "include",
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                dispatch(updateXeroSettings({ tenants: tenants.filter((t) => t.connectionId != connectionId) }))
            })
    }
}

const updateTenant = (tenant) => {
    return async (dispatch, getState) => {
        await fetch(apiURL + "/xero/update-tenant", {
            // fetch('http://localhost:3000/report/templates' , {
            credentials: "include",
            method: "POST",
            body: JSON.stringify({ "xero-tenant-id": tenant }),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                dispatch(updateXeroSettings({ tenant }))
                dispatch(getXeroSettings())
            })
    }
}

const sendPayPeriodToXero = (periodId) => {
    return async (dispatch, getState) => {
        NotificationManager.info(`Sending Payroll Data`, 'Sending Payroll to Xero');

        dispatch(setSendingData(periodId, true))
        await fetch(apiURL + '/xero/payrun', {
            // fetch('http://localhost:3000/report/templates' , {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify({ payrun: periodId }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (!data.success && data.message) {
                    NotificationManager.error(`${data.message}`, 'Sending Payroll to Xero');
                } else {
                    dispatch(getXeroSettings())
                    NotificationManager.success(`Payroll Data has been sent successfully!`, 'Sending Payroll to Xero');
                }
            })
            .catch(error => {
                console.error(error)
                NotificationManager.error(`Error Sending Payroll Data`, 'Sending Payroll to Xero');
            })
        dispatch(setSendingData(periodId))
    }
}

const connectXero = () => {
    return (dispatch, getState) => {

        fetch(apiURL + "/xero/is-connected", {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                window.open(data.url)
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error('Error Connecting Xero', 'Connect Xero')
            })
    }
}

const getXeroContacts = async (inputValue) => {
    return new Promise(async (resolve) => {
        await axios({
            url: apiURL + `/xero/contacts${constructQueryParams({ name: inputValue })}`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            withCredentials: true
        })
            .then(({ data }) => {
                const { Contacts } = { ...data?.data }
                if (!Contacts) resolve([])
                else resolve(Contacts?.map(({ Name: label, ContactID: value }) => ({ label, value })))
            })
    })
}

const getContactOptions = (inputValue) => {
    return async (dispatch, getState) => {
        const contacts = await getXeroContacts(inputValue)
        dispatch(updateContactOptions(contacts))
    }
}

const Actions = {
    sendPayPeriodToXero,
    getContactOptions,
    updateTenant,
    disconnectOrganisation,
    isConnectedToXero,
    saveXeroSettings,
    getXeroContacts,
    connectXero
}

export { Types, Actions }
